import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { APP_BASE_HREF, CommonModule, PlatformLocation } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ClipboardModule } from 'ngx-clipboard';
import { MarkdownModule } from 'ngx-markdown';

import { ApiModule, BASE_PATH } from './@api/client-api';

import { AppRoutingModule } from './app-routing.module';
import { RootStoreModule } from './store/root-store.module';

import { AppComponent } from './app.component';
import {CookieService} from 'ngx-cookie-service';

import { 
  SubscribePageComponent, 
  ConfirmationPageComponent, 
  ErrorPageComponent
} from './components/pages';
import { SubscriptionTopicsComponent } from './components/pages/subscribe-page/subscription-topics/subscription-topics.component';
import { SubscriberDetailsComponent } from './components/pages/subscribe-page/subscriber-details/subscriber-details.component';


function resolveAppBaseHref(location: PlatformLocation) {
  return location.getBaseHrefFromDOM();
}

function resolveApiBasePath(appBaseHref: string) {
  // API base path is relative to AppBaseHref
  // Remove trailing '/' to make path relative to host address
  if (!appBaseHref)
    return '';
  if (appBaseHref[appBaseHref.length - 1] === '/') {
    return appBaseHref.slice(0, -1);
  }
  return '';
}

@NgModule({
  declarations: [
    AppComponent,
    SubscriberDetailsComponent,
    SubscriptionTopicsComponent,
    SubscribePageComponent,
    ConfirmationPageComponent,
    ErrorPageComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ApiModule,
    HttpClientModule,
    CommonModule,
    FormsModule,
    ClipboardModule,
    RootStoreModule,
    MarkdownModule.forRoot()
  ],
  providers: [
    CookieService,
    { provide: APP_BASE_HREF, useFactory: resolveAppBaseHref, deps: [PlatformLocation] },
    { provide: BASE_PATH, useFactory: resolveApiBasePath, deps: [APP_BASE_HREF] }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
